const validationKeysBG = {
  translation: {
    "v-key-username": "Потребителско име",
    "v-key-email": "Електронна поща",
    "v-key-firstName": "Име",
    "v-key-middleName": "Презиме",
    "v-key-lastName": "Фамилия",
    "v-key-personalId": "Идентификатор",
    "v-key-dateOfBirth": "Дата на раждане",
    "v-key-representedUniversity": "Представляван университет",
    "v-key-representativeCapacity": "Качество на представителя",
    "v-key-password": "Парола",
    "v-key-confirmPassword": "Парола (Въведете отново)",
    "v-key-representedCompany": "Представлявана фирма (ЕИК)",
    "v-key-birthPlace": "Населено място на раждане",
    "v-key-birthCountry.id": "Държава на раждане",
    "v-key-contactAddress.city": "Населено място (Адрес за контакт)",
    "v-key-contactAddress.postCode": "Пощенски код (Адрес за контакт)",
    "v-key-contactAddress.address": "Адрес (Адрес за контакт)",
    "v-key-contactAddress.phone": "Телефон (Адрес за контакт)",
    "v-key-contactAddress.postBox": "Пощенска кутия (Адрес за контакт)",
    "v-key-contactAddress.email": "Електронна поща (Адрес за контакт)",
    "v-key-contactAddress.fax": "Факс (Адрес за контакт)",
    "v-key-receiverAddress.city": "Населено място (Адрес на получател)",
    "v-key-receiverAddress.postCode": "Пощенски код (Адрес на получател)",
    "v-key-receiverAddress.address": "Адрес (Адрес на получател)",
    "v-key-receiverAddress.phone": "Телефон (Адрес на получател)",
    "v-key-receiverAddress.name": "Име на получател (Адрес на получател)",
    "v-key-birthSettlement.id": "Населено място",
    "v-key-foreignerIdentifierKind.id": "Вид чуждестранен идентификатор",
    "v-key-foreignerIdentifierCountry.id": "Държава, издала чуждестранния идентификатор",
    "v-key-citizenship.id": "Гражданство",
    "v-key-title": "Обръщение",
  },
};

export default validationKeysBG;
